<div class="verify-wrap">
  <div *ngIf="loading" class="card p-4">Verifying against the blockchain…</div>

  <div *ngIf="notFound" class="card p-4 verify-banner verify-banner--alert">
    No advance directive matches this code.
  </div>

  <!-- MINIMAL tier: emergency summary (this device is not registered) -->
  <app-emergency-summary-card *ngIf="minimal" [summary]="minimal"></app-emergency-summary-card>

  <ng-container *ngIf="directive">
    <!-- Integrity banner -->
    <div
      class="verify-banner"
      [ngClass]="directive.integrityVerified ? 'verify-banner--ok' : (directive.integrityResult === 'fail' ? 'verify-banner--alert' : 'verify-banner--warn')"
    >
      <ng-container *ngIf="directive.integrityVerified">✓ BLOCKCHAIN VERIFIED — this directive is authentic and untampered.</ng-container>
      <ng-container *ngIf="!directive.integrityVerified && directive.integrityResult === 'fail'">⚠ INTEGRITY CHECK FAILED — this document does NOT match its blockchain proof. Treat with caution.</ng-container>
      <ng-container *ngIf="!directive.integrityVerified && directive.integrityResult !== 'fail'">Integrity could not be verified right now. Access has been recorded.</ng-container>
    </div>

    <div *ngIf="!directive.isCurrentVersion" class="verify-banner verify-banner--warn mt-2">
      ⚠ This is NOT the current version of the patient's directive.
    </div>

    <div class="card p-4 mt-3">
      <h4>{{ directive.payload?.demographics?.fullName }}</h4>
      <p class="text-muted">
        <ng-container *ngIf="directive.payload?.demographics?.dateOfBirth">Date of birth: {{ directive.payload?.demographics?.dateOfBirth }} · </ng-container>
        {{ docTypeLabel }} · v{{ directive.version }}
      </p>

      <p *ngIf="directive.payload?.healthCareAgent?.name" class="mb-1">
        <strong>Health-care agent:</strong>
        {{ directive.payload?.healthCareAgent?.name }}
        <span *ngIf="directive.payload?.healthCareAgent?.relationship">({{ directive.payload?.healthCareAgent?.relationship }})</span>
        <span *ngIf="directive.payload?.healthCareAgent?.phone"> · {{ directive.payload?.healthCareAgent?.phone }}</span>
      </p>

      <h6 class="mt-3">Treatment wishes</h6>
      <ul>
        <li *ngIf="directive.payload?.livingWill?.cpr"><strong>CPR:</strong> {{ directive.payload?.livingWill?.cpr }}</li>
        <li *ngIf="directive.payload?.livingWill?.mechanicalVentilation"><strong>Mechanical ventilation:</strong> {{ directive.payload?.livingWill?.mechanicalVentilation }}</li>
        <li *ngIf="directive.payload?.livingWill?.feedingTube"><strong>Feeding tube:</strong> {{ directive.payload?.livingWill?.feedingTube }}</li>
        <li *ngIf="directive.payload?.livingWill?.dialysis"><strong>Dialysis:</strong> {{ directive.payload?.livingWill?.dialysis }}</li>
        <li *ngIf="directive.payload?.livingWill?.comfortCareOnly"><strong>Comfort care only</strong></li>
      </ul>

      <!-- The patient's own written words: line breaks preserved, not squashed into a bullet. -->
      <ng-container *ngIf="freeText.length">
        <h6 class="mt-3">In the patient's own words</h6>
        <p *ngFor="let text of freeText" class="own-words">{{ text }}</p>
      </ng-container>

      <p class="text-muted small mt-3">
        Signed by:
        <span *ngFor="let s of directive.signatures; let last = last">{{ s.signerName }} ({{ s.role }}){{ last ? '' : ', ' }}</span>
      </p>
      <p class="text-muted small">
        Blockchain proof: {{ directive.anchoredTxId || directive.blockchainTxId }} · This access has been recorded in a tamper-evident audit log.
      </p>
    </div>
  </ng-container>
</div>
